import React, { useEffect } from "react";
import './style.css'

export default function Home() {
    useEffect(() => {
        const h2 = document.querySelector('.h2-typewriter')
        const TypeWriter = (elemento) => {
            const textoArray = elemento.innerHTML.split('');
            elemento.innerHTML = ''
            textoArray.forEach((letra, i) => {
                setTimeout(() => elemento.innerHTML += letra, 200 * i)
            })
        }
        TypeWriter(h2)
    }, []);

    return (
        <section className='Home' id="Inicio">
            <div className="conteudo-home">
                <div className='titulo-home'>
                    <p>Olá, meu nome é</p>
                    <h1>Pedro Lisboa</h1>
                    <h2 className="h2-typewriter">Desenvolvedor Front-End</h2>
                </div>
                <div className="emote-home">
                    <img src='/assets/imgProfile.png' alt="Imagem Profile"/>
                </div>
            </div>
        </section>
    )
} 